export default "__VITE_ASSET__CL6TxRgr__"